export default "__VITE_ASSET__99459182__"